// extracted by mini-css-extract-plugin
module.exports = {"warningMessage":"AnimalRow_warningMessage__2JBoy","bulkSelect":"AnimalRow_bulkSelect__3jLBe"};